import { AppDomainConstant } from "../../app-domain.constant";

export class LiquidacionesAPIConstant {
    static readonly BASE_PARAMETRIZACION_PRODUCTOS: string = 'api/v1/control-operacion-parametrizacion-producto/';
    static readonly MULTI_EMPRESA: string = 'api/v1/multiempresa/';
    static readonly LIQUIDACION: string = 'api/v1/liquidacion/';
    static readonly LIQUIDACION_INGRESO: string = LiquidacionesAPIConstant.LIQUIDACION + 'liquidacion-ingreso';

    static readonly URL_GET_PRODUCTOS: string =
        AppDomainConstant.URI_GATEWAY +
        this.BASE_PARAMETRIZACION_PRODUCTOS +
        'producto';

    static readonly URL_GET_SUBPRODUCTOS: string =
        AppDomainConstant.URI_GATEWAY +
        this.BASE_PARAMETRIZACION_PRODUCTOS +
        'producto/sub-producto'

    static readonly URL_GET_EMPRESAS: string =
        AppDomainConstant.URI_GATEWAY +
        LiquidacionesAPIConstant.MULTI_EMPRESA +
        'empresas';

    static readonly URL_GET_LIQUIDACION_INGRESO: string =
        AppDomainConstant.URI_GATEWAY +
        LiquidacionesAPIConstant.LIQUIDACION_INGRESO;

    static readonly URL_POST_RELIQUIDAR: string =
        AppDomainConstant.URI_GATEWAY +
        LiquidacionesAPIConstant.LIQUIDACION_INGRESO +
        '/re-liquidation/';

}